"use strict";
export const classes = {
  popover: {
    pointerEvents: "none",
    "& .MuiPopover-paper": {
      backgroundColor: "#CDD7F2",
      color: "white",
      padding: "8px 12px",
      borderRadius: "16px 16px 16px 0px",
      maxWidth: "300px",
      marginBottom: "8px",
      boxShadow: "0px 4px 8px -2px rgba(57, 113, 138, 0.10), 0px 4px 20px 3px rgba(57, 113, 138, 0.06)"
    }
  },
  feedbackInputHelperText: {
    fontFamily: "Source Sans Pro",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "16px",
    textAlign: "right"
  }
};
